import React, { useContext, useEffect, useState } from "react";
import { SelectedElementContex } from "../../context/SelectedElement";
import InputField from "./Settings/InputField";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import ColorPickerField from "./Settings/ColorPickerField";
import InputStyleField from "./Settings/InputStyleField";
import SliderField from "./Settings/SliderField";
// import TextAreaField from "./Settings/TextAreaField";
import ToogleGroupField from "./Settings/ToogleGroupField";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import DropDownField from "./Settings/DropDownField";
import ImagePreview from "./Settings/ImagePreview";
import { CaseUpper, CaseLower, CaseSensitive, Plus, Minus } from "lucide-react";
import { TextEditorContext } from "../../context/TextEditorContext";
import ToogleGroupSelectedText from "./Settings/ToggleGroupSelectedText";
import { Bold, Italic, Underline, Highlighter } from "lucide-react";
import ImagePreviewTextField from "./Settings/ImagePreviewTextField";

import { Tabs, Tab, Box } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { TableRowColumnIndexContex } from "../../context/TableRowColumnIndexContex";
import DatabaseDropdownFields from "./Settings/DatabaseDropdownFields";
import AnchorFieldSelectedText from "./Settings/AnchorFieldSelectedText";

const TextAlignOptions = [
  {
    value: "left",
    icon: <FormatAlignLeftIcon />,
  },
  {
    value: "center",
    icon: <FormatAlignCenterIcon />,
  },
  {
    value: "right",
    icon: <FormatAlignRightIcon />,
  },

  {
    value: "justify",
    icon: <FormatAlignJustifyIcon />,
  },
];

const TextTransformOptions = [
  {
    value: "uppercase",
    icon: <CaseUpper />,
  },
  {
    value: "lowercase",
    icon: <CaseLower />,
  },
  {
    value: "capitalize",
    icon: <CaseSensitive />,
  },
];

const HrTransformOptions = [
  {
    value: "top",
    icon: <CaseUpper />,
  },
  {
    value: "middle",
    icon: <CaseLower />,
  },
  {
    value: "bottom",
    icon: <CaseSensitive />,
  },
];

const TextSelectionOptions = [
  {
    title: "Bold",
    value: { fontWeight: "bold" },
    icon: <Bold />,
  },
  {
    title: "Italic",
    value: { fontStyle: "italic" },
    icon: <Italic />,
  },
  {
    title: "Underline",
    value: { textDecoration: "underline" },
    icon: <Underline />,
  },
  // {
  //   value: { color: "#07f223" },
  //   icon: "Color",
  // },
  {
    title: "Highlighter",
    value: { backgroundColor: "#ffff00" },
    icon: <Highlighter />,
  },
];

function Settings() {
  const { selectedElement, setSelectedElement } = useContext(
    SelectedElementContex
  );
  const { indexRow, indexColumn, setIndexRow, setIndexColumn } = useContext(
    TableRowColumnIndexContex
  );
  const [element, setElement] = useState();
  const [tabValue, setTabValue] = useState(0);
  const { applyStyleToSelection, isTextSelected } =
    useContext(TextEditorContext);

  // Add these new state variables for SocialHandles
  const [showSocialDropdown, setShowSocialDropdown] = useState(false);
  const [selectedSocialPlatform, setSelectedSocialPlatform] = useState("");
  const [newSocialUrl, setNewSocialUrl] = useState("");

  // Add handler for social icon changes
  const onHandleSocialIconChange = (index, field, value) => {
    const updatedElement = {
      ...selectedElement,
      layout: {
        ...selectedElement?.layout,
        [selectedElement?.index]: {
          ...selectedElement?.layout[selectedElement?.index],
          socialIcons: selectedElement?.layout[
            selectedElement?.index
          ]?.socialIcons.map((icon, idx) =>
            idx === index ? { ...icon, [field]: value } : icon
          ),
        },
      },
    };
    setSelectedElement(updatedElement);
  };

  // Add handler for adding new social handle
  const addSocialHandle = () => {
    if (!selectedSocialPlatform || !newSocialUrl) return;

    const socialIconIndex = element?.socialIcons.findIndex(
      (icon) => icon.name === selectedSocialPlatform
    );

    if (socialIconIndex !== -1) {
      onHandleSocialIconChange(socialIconIndex, "url", newSocialUrl);
      // Reset states
      setShowSocialDropdown(false);
      setSelectedSocialPlatform("");
      setNewSocialUrl("");
    }
  };

  useEffect(() => {
    // console.log(selectedElement?.layout?.[selectedElement?.index]);
    setElement(selectedElement?.layout?.[selectedElement?.index]);
  }, [selectedElement]);

  const onHandleInputChange = (f_name, value) => {
    const updatedData = { ...selectedElement };
    updatedData.layout[selectedElement.index][f_name] = value;
    setSelectedElement(updatedData);
  };

  const onHandleStyleChange = (f_name, value) => {
    let updatedElement = {
      ...selectedElement,
      layout: {
        ...selectedElement?.layout,
        [selectedElement?.index]: {
          ...selectedElement?.layout[selectedElement?.index],
          style: {
            ...selectedElement?.layout[selectedElement?.index]?.style,
            [f_name]: value,
          },
        },
      },
    };
    setSelectedElement(updatedElement);
  };

  const onHandleTableStyleChange = (f_name, value) => {
    if (!selectedElement?.layout || selectedElement?.index === undefined)
      return;
    let updatedElement = {
      ...selectedElement,
      layout: {
        ...selectedElement?.layout,
        [selectedElement?.index]: {
          ...selectedElement?.layout[selectedElement?.index],
          tableStyle: {
            ...selectedElement?.layout[selectedElement?.index]?.tableStyle,
            [f_name]: value,
          },
        },
      },
    };
    setSelectedElement(updatedElement);
  };

  const onHandleCellsStyleChange = (indexRow, indexColumn, f_name, value) => {
    if (!selectedElement?.layout || selectedElement?.index === undefined)
      return;
    if (indexRow === null || indexColumn === null) return;
    let updatedElement = {
      ...selectedElement,
      layout: {
        ...selectedElement?.layout,
        [selectedElement?.index]: {
          ...selectedElement?.layout[selectedElement?.index],
          cells: selectedElement?.layout[selectedElement?.index]?.cells.map(
            (row, rIdx) =>
              rIdx === indexRow
                ? row.map((cell, cIdx) =>
                    cIdx === indexColumn
                      ? {
                          ...cell,
                          style: {
                            ...cell.style,
                            [f_name]: value,
                          },
                        }
                      : cell
                  )
                : row
          ),
        },
      },
    };
    setSelectedElement(updatedElement);
  };

  const onHandleOuterStyleChange = (f_name, value) => {
    let updatedElement = {
      ...selectedElement,
      layout: {
        ...selectedElement?.layout,
        [selectedElement?.index]: {
          ...selectedElement?.layout[selectedElement?.index],
          outerStyle: {
            ...selectedElement?.layout[selectedElement?.index]?.outerStyle,
            [f_name]: value,
          },
        },
      },
    };
    setSelectedElement(updatedElement);
  };

  // URL specific handlers
  const onHandleUrlElementChange = (index, field, value) => {
    const updatedElement = {
      ...selectedElement,
      layout: {
        ...selectedElement?.layout,
        [selectedElement?.index]: {
          ...selectedElement?.layout[selectedElement?.index],
          urlElements: selectedElement?.layout[
            selectedElement?.index
          ]?.urlElements.map((elem, idx) =>
            idx === index ? { ...elem, [field]: value } : elem
          ),
        },
      },
    };
    setSelectedElement(updatedElement);
  };

  const addNewUrlElement = () => {
    const updatedElement = {
      ...selectedElement,
      layout: {
        ...selectedElement?.layout,
        [selectedElement?.index]: {
          ...selectedElement?.layout[selectedElement?.index],
          urlElements: [
            ...selectedElement?.layout[selectedElement?.index]?.urlElements,
            { sidetext: "Click here :", url: "#" },
          ],
        },
      },
    };
    setSelectedElement(updatedElement);
  };

  const removeUrlElement = (index) => {
    const updatedElement = {
      ...selectedElement,
      layout: {
        ...selectedElement?.layout,
        [selectedElement?.index]: {
          ...selectedElement?.layout[selectedElement?.index],
          urlElements: selectedElement?.layout[
            selectedElement?.index
          ]?.urlElements.filter((_, idx) => idx !== index),
        },
      },
    };
    setSelectedElement(updatedElement);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Table functions:

  const updateTableElement = (updatedTable) => {
    const updated = { ...selectedElement };
    updated.layout[selectedElement.index] = updatedTable;
    setSelectedElement(updated);
  };

  const addColumn = (afterColIndex) => {
    const table = selectedElement.layout[selectedElement.index];

    const updated = {
      ...table,
      cols: table.cols + 1,
      cells: table.cells.map((row) => {
        const newRow = [...row];
        // Insert new cell after the specified column index
        newRow.splice(afterColIndex + 1, 0, {
          content: "",
          style: {
            padding: "10px",
            border: "1px solid #9CA3AF",
            color: "#000",
            fontSize: "14px",
            fontWeight: "normal",
            textAlign: "left",
            backgroundColor: "#ffffff",
          },
        });
        return newRow;
      }),
    };

    updateTableElement(updated);
  };

  const addRow = (afterRowIndex) => {
    const table = selectedElement.layout[selectedElement.index];

    const newRow = Array.from({ length: table.cols }).map(() => ({
      content: "",
      style: {
        padding: "10px",
        border: "1px solid #9CA3AF",
        color: "#000",
        fontSize: "14px",
        fontWeight: "normal",
        textAlign: "left",
        backgroundColor: "#ffffff",
      },
    }));

    const updatedCells = [...table.cells];
    // Insert new row after the specified row index
    updatedCells.splice(afterRowIndex + 1, 0, newRow);

    const updated = {
      ...table,
      rows: table.rows + 1,
      cells: updatedCells,
    };

    updateTableElement(updated);
  };

  const deleteColumn = (colIndex) => {

    const table = selectedElement.layout[selectedElement.index];

    const updated = {
      ...table,
      cols: table.cols - 1,
      cells: table.cells.map((row) => row.filter((_, i) => i !== colIndex)),
    };

    updateTableElement(updated);
  };

  const deleteRow = (rowIndex) => {
    const table = selectedElement.layout[selectedElement.index];

    const updated = {
      ...table,
      rows: table.rows - 1,
      cells: table.cells.filter((_, i) => i !== rowIndex),
    };

    updateTableElement(updated);
  };

  return (
    <div className="p-5 flex flex-col gap-4 bg-gradient-to-b from-blue-100 to-white h-[90vh] overflow-y-auto">

      <div className="p-3 backdrop-blur-sm">
        <div className="flex items-center gap-2">
          <div className="w-1 h-6 bg-gradient-to-b from-indigo-600 to-purple-600 rounded-full"></div>
          <h2 className="font-bold text-xl text-gray-800">Customize</h2>
        </div>
      </div>
      {/* <h2 className="font-bold text-xl">Settings</h2> */}

      {(element?.type === "Text" || element?.type === "Table") && <DatabaseDropdownFields />}

      {element?.type === "Url" && (
        <Box sx={{ width: "100%" }}>
          <Tabs value={tabValue} onChange={handleTabChange} variant="fullWidth">
            <Tab label="Styles" />
            <Tab label="Edit" />
          </Tabs>

          {/* Settings Tab */}
          {tabValue === 0 && (
            <Box
              sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}
            >
              <ColorPickerField
                label="Background Color"
                value={element?.style?.backgroundColor}
                onHandleStyleChange={(value) =>
                  onHandleStyleChange("backgroundColor", value)
                }
              />

              <InputStyleField
                label={"Font Size"}
                value={element?.style?.fontSize}
                onHandleStyleChange={(value) =>
                  onHandleStyleChange("fontSize", value)
                }
              />

              <ToogleGroupField
                label={"Text Transform"}
                value={element?.style?.textTransform}
                options={TextTransformOptions}
                onHandleStyleChange={(value) =>
                  onHandleStyleChange("textTransform", value)
                }
              />

              <ToogleGroupField
                label={"Text Align"}
                value={element?.style?.textAlign}
                options={TextAlignOptions}
                onHandleStyleChange={(value) =>
                  onHandleStyleChange("textAlign", value)
                }
              />

              <InputStyleField
                label={"Padding"}
                value={element?.style?.padding}
                onHandleStyleChange={(value) =>
                  onHandleStyleChange("padding", value)
                }
              />

              <DropDownField
                label={"Font Weight"}
                options={["normal", "bold"]}
                value={element?.style?.fontWeight}
                onHandleStyleChange={(value) =>
                  onHandleStyleChange("fontWeight", value)
                }
              />
            </Box>
          )}

          {/* Edit URLs Tab */}
          {tabValue === 1 && (
            <Box
              sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}
            >
              {element?.urlElements?.map((urlElem, index) => (
                <Box
                  key={index}
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    padding: "16px",
                    position: "relative",
                  }}
                >
                  <button
                    onClick={() => removeUrlElement(index)}
                    style={{
                      position: "absolute",
                      top: "8px",
                      right: "8px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#d32f2f",
                    }}
                    title="Remove URL"
                  >
                    <Delete />
                  </button>

                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <Box>
                      <label className="text-sm font-medium">Side Text</label>
                      <input
                        type="text"
                        value={urlElem.sidetext}
                        onChange={(e) =>
                          onHandleUrlElementChange(
                            index,
                            "sidetext",
                            e.target.value
                          )
                        }
                        className="border rounded px-3 py-2 text-sm w-full mt-1"
                        placeholder="Enter side text"
                      />
                    </Box>

                    <Box>
                      <label className="text-sm font-medium">URL</label>
                      <input
                        type="text"
                        value={urlElem.url}
                        onChange={(e) =>
                          onHandleUrlElementChange(index, "url", e.target.value)
                        }
                        className="border rounded px-3 py-2 text-sm w-full mt-1"
                        placeholder="Enter URL"
                      />
                    </Box>
                  </Box>
                </Box>
              ))}

              <button
                onClick={addNewUrlElement}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  border: "2px dashed #e0e0e0",
                  borderRadius: "8px",
                  padding: "12px",
                  background: "none",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                <Add />
                <span>Add New URL</span>
              </button>
            </Box>
          )}
        </Box>
      )}

      {element?.type === "SocialHandles" && (
        <Box sx={{ width: "100%" }}>
          <Tabs value={tabValue} onChange={handleTabChange} variant="fullWidth">
            <Tab label="Styles" />
            <Tab label="Edit" />
          </Tabs>

          {/* Settings Tab */}
          {tabValue === 0 && (
            <Box
              sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}
            >
              <ColorPickerField
                label="Background Color"
                value={element?.style?.backgroundColor}
                onHandleStyleChange={(value) =>
                  onHandleStyleChange("backgroundColor", value)
                }
              />

              <ToogleGroupField
                label="Align"
                value={element?.style?.align}
                onHandleStyleChange={(value) =>
                  onHandleStyleChange("align", value)
                }
                options={TextAlignOptions}
              />

              <InputStyleField
                label={"Padding"}
                value={element?.style?.padding}
                onHandleStyleChange={(value) =>
                  onHandleStyleChange("padding", value)
                }
              />

              <SliderField
                label={"Icon width"}
                value={element?.outerStyle?.width}
                // type="%"
                onHandleStyleChange={(value) =>
                  onHandleOuterStyleChange("width", value)
                }
              />
              <InputStyleField
                label={"Margin right"}
                value={element?.style?.marginRight}
                onHandleStyleChange={(value) =>
                  onHandleStyleChange("marginRight", value)
                }
              />
              <InputStyleField
                label={"Margin bottom"}
                value={element?.style?.marginBottom}
                onHandleStyleChange={(value) =>
                  onHandleStyleChange("marginBottom", value)
                }
              />
            </Box>
          )}

          {/* Edit Tab for SocialHandles */}
          {tabValue === 1 && (
            <Box
              sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}
            >
              {/* Display existing social handles that have URLs */}
              {element?.socialIcons
                ?.filter((icon) => icon.url !== "")
                .map((icon, originalIndex) => {
                  // Find the actual index in the original array
                  const actualIndex = element.socialIcons.findIndex(
                    (item) => item.name === icon.name
                  );

                  return (
                    <Box
                      key={actualIndex}
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        padding: "16px",
                        position: "relative",
                      }}
                    >
                      <button
                        onClick={() =>
                          onHandleSocialIconChange(actualIndex, "url", "")
                        }
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          color: "#d32f2f",
                        }}
                        title="Remove URL"
                      >
                        <Delete />
                      </button>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <Box>
                          <label className="text-sm font-medium block mb-1">
                            Platform Name
                          </label>
                          <div className="border rounded px-3 py-2 text-sm w-full bg-gray-50 capitalize">
                            {icon.name}
                          </div>
                        </Box>

                        <Box>
                          <label className="text-sm font-medium block mb-1">
                            URL
                          </label>
                          <input
                            type="text"
                            value={icon.url}
                            onChange={(e) =>
                              onHandleSocialIconChange(
                                actualIndex,
                                "url",
                                e.target.value
                              )
                            }
                            className="border rounded px-3 py-2 text-sm w-full mt-1"
                            placeholder="Enter URL"
                          />
                        </Box>
                      </Box>
                    </Box>
                  );
                })}

              {/* Add New Social Handle - Conditional Rendering */}
              {!showSocialDropdown ? (
                <button
                  onClick={() => setShowSocialDropdown(true)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    border: "2px dashed #e0e0e0",
                    borderRadius: "8px",
                    padding: "12px",
                    background: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  <Add />
                  <span>Add New</span>
                </button>
              ) : (
                <Box
                  sx={{
                    border: "2px solid #e0e0e0",
                    borderRadius: "8px",
                    padding: "16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <FormControl fullWidth>
                    <InputLabel id="social-platform-select-label">
                      Select Platform
                    </InputLabel>
                    <Select
                      labelId="social-platform-select-label"
                      id="social-platform-select"
                      value={selectedSocialPlatform}
                      label="Select Platform"
                      onChange={(e) =>
                        setSelectedSocialPlatform(e.target.value)
                      }
                    >
                      {element?.socialIcons
                        ?.filter((icon) => icon.url === "")
                        .map((icon, index) => (
                          <MenuItem key={index} value={icon.name}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <img
                                src={icon.iconImage}
                                alt={icon.name}
                                style={{ width: "20px", height: "20px" }}
                              />
                              <span className="capitalize">{icon.name}</span>
                            </Box>
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>

                  {selectedSocialPlatform && (
                    <Box>
                      <label className="text-sm font-medium block mb-1">
                        URL
                      </label>
                      <input
                        type="text"
                        value={newSocialUrl}
                        onChange={(e) => setNewSocialUrl(e.target.value)}
                        className="border rounded px-3 py-2 text-sm w-full"
                        placeholder="Enter URL"
                      />
                    </Box>
                  )}

                  <Box
                    sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}
                  >
                    <button
                      onClick={() => {
                        setShowSocialDropdown(false);
                        setSelectedSocialPlatform("");
                        setNewSocialUrl("");
                      }}
                      style={{
                        padding: "8px 16px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "4px",
                        background: "white",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={addSocialHandle}
                      disabled={!selectedSocialPlatform || !newSocialUrl}
                      style={{
                        padding: "8px 16px",
                        border: "none",
                        borderRadius: "4px",
                        background:
                          selectedSocialPlatform && newSocialUrl
                            ? "#1976d2"
                            : "#e0e0e0",
                        color: "white",
                        cursor:
                          selectedSocialPlatform && newSocialUrl
                            ? "pointer"
                            : "not-allowed",
                        fontSize: "14px",
                      }}
                    >
                      Add
                    </button>
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </Box>
      )}
      {/* 1 */}
      {element?.type === "Text" && !isTextSelected && (
        <ImagePreviewTextField
          label={"Image Preview"}
          value={element?.imageUrl}
          onHandleInputChange={(value) =>
            onHandleInputChange("imageUrl", value)
          }
        />
      )}

      {/* Table Styles: */}

      {element?.type === "Table" && !isTextSelected && (
        <>
          {indexColumn !== null &&
            indexColumn !== undefined &&
            indexRow !== null &&
            indexRow !== undefined && (
              <div className="flex gap-2 mb-4">
                <button
                  onClick={() => {
                    addRow(indexRow);
                    setIndexColumn(null);
                    setIndexRow(null);
                  }}
                  className="flex items-center justify-center gap-1 px-2 py-1.5 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 flex-1"
                >
                  <span>+</span>
                  <span>Row</span>
                </button>
                <button
                  onClick={() => {
                    addColumn(indexColumn);
                    setIndexColumn(null);
                    setIndexRow(null);
                  }}
                  className="flex items-center justify-center gap-1 px-2 py-1.5 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 flex-1"
                >
                  <span>+</span>
                  <span>Column</span>
                </button>
                <button
                  onClick={() => {
                    deleteRow(indexRow);
                    setIndexColumn(null);
                    setIndexRow(null);
                  }}
                  className="flex items-center justify-center gap-1 px-2 py-1.5 bg-red-500 text-white text-xs rounded hover:bg-red-600 flex-1"
                >
                  <span>-</span>
                  <span>Row</span>
                </button>
                <button
                  onClick={() => {
                    deleteColumn(indexColumn);
                    setIndexColumn(null);
                    setIndexRow(null);
                  }}
                  className="flex items-center justify-center gap-1 px-2 py-1.5 bg-red-500 text-white text-xs rounded hover:bg-red-600 flex-1"
                >
                  <span>-</span>
                  <span>Col</span>
                </button>
              </div>
            )}

          <label className="text-sm font-medium block">Table:</label>
          <ToogleGroupField
            label={"Align"}
            value={element?.tableStyle?.align}
            options={TextAlignOptions}
            onHandleStyleChange={(value) =>
              onHandleTableStyleChange("align", value)
            }
          />
          <ColorPickerField
            label="Background Color"
            value={element?.tableStyle?.backgroundColor}
            onHandleStyleChange={(value) =>
              onHandleTableStyleChange("backgroundColor", value)
            }
          />
          <SliderField
            label={"Width"}
            value={element?.tableStyle?.width}
            type="%"
            onHandleStyleChange={(value) =>
              onHandleTableStyleChange("width", value)
            }
          />

          {indexColumn !== null &&
            indexColumn !== undefined &&
            indexRow !== null &&
            indexRow !== undefined && (
              <>
                <label className="text-sm font-medium">
                  Cells:
                </label>
                <ToogleGroupField
                  label={"Text Align"}
                  value={
                    element?.cells[indexRow][indexColumn]?.style?.textAlign
                  }
                  options={TextAlignOptions}
                  onHandleStyleChange={(value) =>
                    onHandleCellsStyleChange(
                      indexRow,
                      indexColumn,
                      "textAlign",
                      value
                    )
                  }
                />
                <ColorPickerField
                  label="Background Color"
                  value={
                    element?.cells[indexRow][indexColumn]?.style
                      ?.backgroundColor
                  }
                  onHandleStyleChange={(value) =>
                    onHandleCellsStyleChange(
                      indexRow,
                      indexColumn,
                      "backgroundColor",
                      value
                    )
                  }
                />
                <ColorPickerField
                  label="Font Color"
                  value={element?.cells[indexRow][indexColumn]?.style?.color}
                  onHandleStyleChange={(value) =>
                    onHandleCellsStyleChange(
                      indexRow,
                      indexColumn,
                      "color",
                      value
                    )
                  }
                />
                <InputStyleField
                  label={"Font Size"}
                  value={element?.cells[indexRow][indexColumn]?.style?.fontSize}
                  onHandleStyleChange={(value) =>
                    onHandleCellsStyleChange(
                      indexRow,
                      indexColumn,
                      "fontSize",
                      value
                    )
                  }
                />
                <DropDownField
                label={"Font Weight"}
                options={["normal", "bold"]}
                value={element?.cells[indexRow][indexColumn]?.style?.fontWeight}
                onHandleStyleChange={(value) =>
                  onHandleCellsStyleChange(
                      indexRow,
                      indexColumn,
                      "fontWeight",
                      value
                    )
                }
              />
                
              </>
            )}
        </>
      )}

      {/* 2 */}
      {element?.type === "Text" && isTextSelected && (
        <div className="flex flex-col gap-2">
          <ToogleGroupSelectedText options={TextSelectionOptions} />
          <AnchorFieldSelectedText/>
        </div>
      )}

      {element?.type === "Table" && isTextSelected && <AnchorFieldSelectedText />}

      {(element?.type === "Image" || element?.type === "Logo") && (
        <ImagePreview
          label={"Image Preview"}
          value={element?.imageUrl}
          onHandleInputChange={(value) =>
            onHandleInputChange("imageUrl", value)
          }
        />
      )}

      {element?.type === "Button" && (
        <>
          <InputField
            label={"Content"}
            value={element?.content}
            onHandleInputChange={(value) =>
              onHandleInputChange("content", value)
            }
          />
          <InputStyleField
            label={"Width"}
            value={element?.style?.width}
            onHandleStyleChange={(value) => onHandleStyleChange("width", value)}
          />
          <InputStyleField
            label={"Height"}
            value={element?.style?.height}
            onHandleStyleChange={(value) =>
              onHandleStyleChange("height", value)
            }
          />
        </>
      )}

      {(element?.type === "Button" ||
        element?.type === "Image" ||
        element?.type === "Logo") && (
        <InputField
          label={"url"}
          value={element?.url}
          onHandleInputChange={(value) => onHandleInputChange("url", value)}
        />
      )}

      {(element?.type === "Image" ||
        element?.type === "Logo" ||
        element?.type === "Divider") && (
        <SliderField
          label={"Width"}
          value={element?.style?.width}
          type="%"
          onHandleStyleChange={(value) => onHandleStyleChange("width", value)}
        />
      )}

      {element?.type === "Logo" && (
        <>
          <SliderField
            label={"Border radius"}
            value={element?.style?.borderRadius}
            type="%"
            onHandleStyleChange={(value) =>
              onHandleStyleChange("borderRadius", value)
            }
          />
        </>
      )}

      {/* 3 */}
      {(element?.type === "Button" ||
        element?.type === "Image" ||
        element?.type === "Logo" 
        || element?.type === "Text"
      ) &&
        !isTextSelected && (
          <ColorPickerField
            label="Background Color"
            value={element?.style?.backgroundColor}
            onHandleStyleChange={(value) =>
              onHandleStyleChange("backgroundColor", value)
            }
          />
        )}

      {(element?.type === "Button" || element?.type === "Divider") && (
        <ColorPickerField
          label="Text Color"
          value={element?.style?.color}
          onHandleStyleChange={(value) => onHandleStyleChange("color", value)}
        />
      )}

      {element?.type === "Divider" && (
        <>
          <SliderField
            label={"Thickness"}
            value={element?.style?.thickness}
            onHandleStyleChange={(value) =>
              onHandleStyleChange("thickness", value)
            }
          />

          {/* <ToogleGroupField
          label={"Align"}
          value={element?.style?.valign}
          options={HrTransformOptions}
          onHandleStyleChange={(value) =>
            onHandleStyleChange("valign", value)
          }
        /> */}
        </>
      )}

      {/* 4 */}
      {(element?.type === "Button" 
      || element?.type === "Text"
    ) &&
        !isTextSelected && (
          <InputStyleField
            label={"Font Size"}
            value={element?.style?.fontSize}
            onHandleStyleChange={(value) =>
              onHandleStyleChange("fontSize", value)
            }
          />
        )}

        {/* 5 */}
      {element?.type === "Text" && !isTextSelected && (
        <ToogleGroupField
          label={"Text Transform"}
          value={element?.style?.textTransform}
          options={TextTransformOptions}
          onHandleStyleChange={(value) =>
            onHandleStyleChange("textTransform", value)
          }
        />
      )}

      {/* 6 */}
      {(
        element?.type === "Text" || 
      element?.type === "Button") &&
        !isTextSelected && (
          <ToogleGroupField
            label={"Text Align"}
            value={element?.style?.textAlign}
            options={TextAlignOptions}
            onHandleStyleChange={(value) =>
              onHandleStyleChange("textAlign", value)
            }
          />
        )}

        {/* 7 */}
      {(element?.type === "Button" ||
        element?.type === "Image" ||
        element?.type === "Logo" ||
        element?.type === "Text" ||
        element?.type === "Divider") &&
        !isTextSelected && (
          <InputStyleField
            label={"Padding"}
            value={element?.style?.padding}
            onHandleStyleChange={(value) =>
              onHandleStyleChange("padding", value)
            }
          />
        )}

      {element?.type === "Image" && (
        <InputStyleField
          label={"Margin"}
          value={element?.style?.margin}
          onHandleStyleChange={(value) => onHandleStyleChange("margin", value)}
        />
      )}

      {(element?.type === "Button" || element?.type === "Image") && (
        <SliderField
          label={"Border Radius"}
          value={element?.style?.borderRadius}
          onHandleStyleChange={(value) =>
            onHandleStyleChange("borderRadius", value)
          }
        />
      )}

      {/* 8 */}
      {(element?.type === "Button" 
      || element?.type === "Text"
    ) &&
        !isTextSelected && (
          <DropDownField
            label={"Font Weight"}
            options={["normal", "bold"]}
            value={element?.style?.fontWeight}
            onHandleStyleChange={(value) =>
              onHandleStyleChange("fontWeight", value)
            }
          />
        )}

      <div>
        {element?.outerStyle &&
          element?.type !== "Text" &&
          element?.type !== "SocialHandles" &&
          !isTextSelected && <h2 className="font-bold mb-2">Outer Style</h2>}

        {element?.outerStyle?.backgroundColor &&
          element?.type !== "Text" &&
          !isTextSelected && (
            <ColorPickerField
              label="Background Color"
              value={element?.outerStyle?.backgroundColor}
              onHandleStyleChange={(value) =>
                onHandleOuterStyleChange("backgroundColor", value)
              }
            />
          )}

        {(element?.type === "Image" || element?.type === "Logo") && (
          <ToogleGroupField
            label="Align"
            value={element?.outerStyle?.justifyContent}
            onHandleStyleChange={(value) =>
              onHandleOuterStyleChange("align", value)
            }
            options={TextAlignOptions}
          />
        )}
        {element?.type === "Button" && (
          <ToogleGroupField
            label="Align"
            value={element?.outerStyle?.justifyContent}
            onHandleStyleChange={(value) =>
              onHandleOuterStyleChange("align", value)
            }
            options={TextAlignOptions}
          />
        )}
      </div>
    </div>
  );
}

export default Settings;
